import gql from 'graphql-tag';
import ASSET_FRAGMENT from './asset';

const RESOURCE_ASSETS_FRAGMENT = gql`
  fragment BaseResourceAssets on Resource {
    thumbnailAsset {
      ...BaseAsset
    }
    resourceAsset {
      ...BaseAsset
    }
  }
  ${ASSET_FRAGMENT}
`;

export default RESOURCE_ASSETS_FRAGMENT;
